/* unplugin-vue-components disabled */import { render } from "./org-map.vue?vue&type=template&id=35c249d2&scoped=true"
import script from "./org-map.vue?vue&type=script&lang=js"
export * from "./org-map.vue?vue&type=script&lang=js"

import "./org-map.vue?vue&type=style&index=0&id=35c249d2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c249d2"],['__file',"src/components/widgets/org-map/org-map.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35c249d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35c249d2', __exports__)) {
    api.reload('35c249d2', __exports__)
  }
  
  module.hot.accept("./org-map.vue?vue&type=template&id=35c249d2&scoped=true", () => {
    api.rerender('35c249d2', render)
  })

}


export default __exports__